export const ChangeRotate = () => {
    return async (dispatch) => {
        await dispatch({type:"CHANGE_ROTATE"})
    }
};